import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconSquareBehindSquare3"><Path fillRule="evenodd" clipRule="evenodd" d="M16 8V4C16 2.89543 15.1046 2 14 2H4C2.89543 2 2 2.89543 2 4V14C2 15.1046 2.89543 16 4 16H8V20C8 21.1046 8.89543 22 10 22H20C21.1046 22 22 21.1046 22 20V10C22 8.89543 21.1046 8 20 8H16ZM14 16C15.1046 16 16 15.1046 16 14V9.5H20C20.2761 9.5 20.5 9.72386 20.5 10V20C20.5 20.2761 20.2761 20.5 20 20.5H10C9.72386 20.5 9.5 20.2761 9.5 20V16H14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare3;
